"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const placeHolderImplementation = ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
    (0, common_1.debugLog)({
        concentrationReceivables,
        valueConfig,
        totalConcentrationExposure,
    });
    (0, common_1.finleyAssert)(false, 'pointer method is not implemented.');
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'cherryCrossRiverBank1.singleState',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit cherryCrossRiverBank1.singleState`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            (0, common_1.finleyAssert)(_.every(concentrationReceivables, (rec) => _.isString(rec.baseFields.state)), new common_1.error.FinleyError('baseFields.state must be defined to run cherryCrossRiverBank1.singleState'));
            const groupedByState = _.groupBy(concentrationReceivables, (rec) => rec.baseFields.state);
            const standardBorrowingBaseReductions = _.map(_.values(groupedByState), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        method: 'cherryCrossRiverBank1.singleMerchant',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit cherryCrossRiverBank1.singleMerchant`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            (0, common_1.finleyAssert)(_.every(concentrationReceivables, (rec) => _.isString(rec.baseFields.merchant_name)), new common_1.error.FinleyError('baseFields.merchant_name must be defined to run cherryCrossRiverBank1.merchant_name'));
            const groupedByMerchant = _.groupBy(concentrationReceivables, (rec) => rec.baseFields.merchant_name);
            const standardBorrowingBaseReductions = _.map(_.values(groupedByMerchant), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    // Cherry has legacy CA utilizing to these pointer methods
    // these cannot be deleted.
    {
        method: 'cherryCrossRiverBank1.minimumWaInterestRate',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumWaRemainingTerm',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAveragePrincipleBalance',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAttributableToAnySingleMerchant',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAttributableTo3HighestConcentrationMerchants',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsLocatedInASingleState',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsLocatedIn3StatesWithHighestConcentrationOfObligors',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumNotOriginatedByTheBankPartnerOriginator',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsNotHavingEnabledAchAutopay',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRemainingTermGreaterThan24Months',
        pointerImplementation: placeHolderImplementation,
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map